import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';
import { PROGRAM_IDENTIFIERS_ACTION_TYPE } from 'store/system/actions';

const initialState = {};

const programIdentifiersReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case PROGRAM_IDENTIFIERS_ACTION_TYPE.GET_PROGRAM_IDENTIFIERS:
        return payload || initialState;

      case PROGRAM_IDENTIFIERS_ACTION_TYPE.CREATE_PROGRAM_IDENTIFIERS:
      case PROGRAM_IDENTIFIERS_ACTION_TYPE.EDIT_PROGRAM_IDENTIFIERS:
      case PROGRAM_IDENTIFIERS_ACTION_TYPE.GET_PROGRAM_IDENTIFIERS_BY_ID:
        draft[payload.id] = payload;
        break;

      case PROGRAM_IDENTIFIERS_ACTION_TYPE.DELETE_PROGRAM_IDENTIFIERS:
        delete draft[meta.id];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default programIdentifiersReducer;
